import React, { useEffect } from 'react';
import { FormattedMessage, } from 'react-intl';
import { Modal, Form, Input, Select, Button, } from 'antd';

import { DatePicker, } from '../common'
import { filterUtil, } from '../util'
import { ForecastSearchDto } from './api';
import './index.css';
import { Field, useFields } from '../fields';

const { RangePicker } = DatePicker;

export interface Props {
  visible: boolean;
  searchDto: ForecastSearchDto;
  close: () => void;
  handleSearch: (searchDto: ForecastSearchDto) => void;
}

export function ForecastSearch(props: Props) {

  return (
    <Modal
      title={<FormattedMessage tagName='h4' id='common.search' />}
      footer={null}
      visible={props.visible}
      closable={false}
      afterClose={props.close}
      destroyOnClose={true}
      width={560}>
      {props.visible && <ForecastSearchForm {...props} />}
    </Modal>
  );
}

const ForecastSearchForm = (props: Props) => {

  const [form] = Form.useForm<ForecastSearchDto>();

  const supplierOptions = useFields('fullSupplier');
  const itemOptions = useFields('item');

  const supplierTitle = <FormattedMessage id='forecast.supplier' />;
  const supplierNameTitle = <FormattedMessage id='forecast.supplierName' />;
  const itemTitle = <FormattedMessage id='forecast.item' />;
  const itemNameTitle = <FormattedMessage id='forecast.itemName' />;
  const iniDeliveryDateTitle = <FormattedMessage id='forecast.iniDeliveryDate' />;

  useEffect(() => {
    form.setFieldsValue(props.searchDto);
  });

  return (
    <Form
      form={form}
      onFinish={props.handleSearch}
      layout={'horizontal'}
      colon={false}
      size={'large'}
      labelCol={{ span: 6 }}
      wrapperCol={{ span: 15 }}>
      <Form.Item name='suppliers' label={supplierTitle} >
        <Select<Field>
          mode={'multiple'}
          className="select-mutil"
          allowClear={true}
          autoClearSearchValue={false}
          filterOption={filterUtil.selectFilter}
          onSearch={filterUtil.onSearchForm(form, 'suppliers', supplierOptions)}
          loading={supplierOptions.length === 0}
          options={supplierOptions} />
      </Form.Item>
      <Form.Item name='supplierName' label={supplierNameTitle} >
        <Input min={1} max={40}  allowClear={true}/>
      </Form.Item>
      <Form.Item name='items' label={itemTitle} >
        <Select<Field>
          mode={'multiple'}
          className="select-mutil"
          allowClear={true}
          autoClearSearchValue={false}
          filterOption={filterUtil.selectFilter}
          onSearch={filterUtil.onSearchForm(form, 'items', itemOptions)}
          loading={itemOptions.length === 0}
          options={itemOptions} />
      </Form.Item>
      <Form.Item name='itemName' label={itemNameTitle} >
        <Input min={1} max={40} allowClear={true}/>
      </Form.Item>
      <Form.Item name='iniDeliveryDate' label={iniDeliveryDateTitle}
      >
        <RangePicker allowEmpty={[true, true]} style={{ width: '100%' }} allowClear={true}/>
      </Form.Item>
      <Form.Item style={{marginLeft: '20px'}}>
        <div className='search-button' style={{ paddingLeft: '20px' }}>
          <Button className='search-close-btn' onClick={props.close}>
            <FormattedMessage id='common.close' />
          </Button>
          <Button className='search-search-btn' htmlType='submit'>
            <FormattedMessage id='common.search' />
          </Button>
        </div>
      </Form.Item>
    </Form>
  );
};
